

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface ErrorDisplayProps {
  errorMessage: string | null;
  onRetry: () => void;
  isRetrying: boolean;
}

const ErrorDisplay = ({ errorMessage, onRetry, isRetrying }: ErrorDisplayProps) => {
  return (
    <div className="container max-w-6xl py-8 space-y-8">
      <Alert variant="destructive" className="max-w-xl mx-auto">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>
          {errorMessage || "There was a problem loading subscription information. Please refresh the page or try again later."}
        </AlertDescription>
      </Alert>
      <div className="flex justify-center mt-4">
        <Button 
          onClick={onRetry}
          disabled={isRetrying}
        >
          {isRetrying ? (
            <>
              <Spinner className="h-4 w-4 mr-2" />
              Retrying...
            </>
          ) : (
            <>
              <RefreshCw className="h-4 w-4 mr-2" />
              Try Again
            </>
          )}
        </Button>
      </div>
      
      <div className="max-w-xl mx-auto mt-8 p-4 border rounded-md bg-muted/50">
        <h3 className="font-medium mb-2">Troubleshooting Information</h3>
        <p className="text-sm text-muted-foreground mb-4">
          This issue may occur if the Stripe integration is not properly configured. Please check that your Supabase Edge Functions have the required secrets set:
        </p>
        <ul className="list-disc pl-5 text-sm space-y-1">
          <li>STRIPE_SECRET_KEY</li>
          <li>STRIPE_PRICE_ID</li>
          <li>STRIPE_ANNUAL_PRICE_ID</li>
        </ul>
        <p className="text-sm mt-4">
          If you continue experiencing issues, please contact support.
        </p>
      </div>
    </div>
  );
};

export default ErrorDisplay;
